import React, { useCallback, useEffect, useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Descriptions, Row, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'react-jss';
import { FileDoneOutlined } from '@ant-design/icons';
import moment from 'moment';

import { getWorkerJob, clearWorkerJob } from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';
import styles from '../styles';
import constants from '../constants';
import Api from '../Api';
import { errorNotification, successNotification } from '../Snackbar';

const ShowWorkerJob = props => {
  const { match, classes } = props;
  const dispatch = useDispatch();

  const workerJob = useSelector(state => state.workerJob);
  const auth = useSelector(state => state.auth);

  useEffect(() => {
    dispatch(getWorkerJob(match.params.id));
    return () => {
      dispatch(clearWorkerJob());
    };
  }, []);

  const onApprove = useCallback(async () => {
    try {
      await Api.put(`/worker-jobs/${match.params.id}/approve`);
      successNotification('Job approved');
      dispatch(getWorkerJob(match.params.id));
    } catch (err) {
      errorNotification(err);
    }
  }, [match.params.id]);

  const scroll = useMemo(() => ({ x: 1900 }), []);
  const stylesRowKey = useCallback(record => record.id, []);

  const stylesColumns = useMemo(() => {
    const _columns = [
      {
        title: 'Customer',
        dataIndex: 'customer',
      },
      {
        title: 'BPO #',
        dataIndex: 'bpoNo',
      },
      {
        title: 'Product',
        dataIndex: 'product',
      },
      {
        title: 'Style',
        dataIndex: 'style',
      },
      {
        title: 'Description',
        dataIndex: 'styleDescription',
      },
      {
        title: 'Size',
        dataIndex: 'styleSize',
      },
      {
        title: 'Color',
        children: [
          {
            title: 'Base',
            dataIndex: 'baseColor',
          },
          {
            title: 'Print',
            dataIndex: 'printColor',
          },
          {
            title: 'Embroidery',
            dataIndex: 'embroideryColor',
          },
          {
            title: 'Acid Wash',
            dataIndex: 'acidWashColor',
          },
        ],
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
      },
      {
        title: 'Total',
        dataIndex: 'total',
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
      },
    ];

    return _columns;
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Worker Jobs"
        moduleLink="/workers/jobs"
        subModuleName="View Worker Job"
      />
      <div className={classes.tableStyle}>
        <Descriptions column={2} size="small" bordered>
          <Descriptions.Item label="Worker">
            {workerJob.worker}
          </Descriptions.Item>
          <Descriptions.Item label="Receive/Job time">
            {moment(workerJob.jobTime).format('DD MMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Remark">
            {workerJob.remark}
          </Descriptions.Item>
          <Descriptions.Item label="Created By">
            {workerJob.createdBy}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {moment(workerJob.createdAt).format('DD MMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Approved By">
            {workerJob.approvedBy || 'Not approved'}
          </Descriptions.Item>
          <Descriptions.Item label="Approved At">
            {workerJob.approvedAt
              ? moment(workerJob.approvedAt).format('DD MMM YYYY')
              : null}
          </Descriptions.Item>
        </Descriptions>
        <br />
        {workerJob.styles?.length && (
          <>
            <Table
              bordered
              size="small"
              columns={stylesColumns}
              dataSource={workerJob.styles}
              rowKey={stylesRowKey}
              pagination={false}
              scroll={scroll}
              title={() => 'Product Table'}
            />
          </>
        )}
        <br />
        {!workerJob.isApproved &&
          auth.permissions.includes(constants.permissions.approveWorkerJob) && (
            <Row>
              <Button
                className={classes.marginBetweenSelect}
                onClick={onApprove}
                icon={<FileDoneOutlined />}
              >
                Authorize
              </Button>
            </Row>
          )}
      </div>
    </>
  );
};

ShowWorkerJob.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShowWorkerJob);
